import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/msgsearch.png'
import _imports_1 from '@/assets/images/friendScand.png'
import _imports_2 from '@/assets/images/icon_friend_add.png'
import _imports_3 from '@/assets/images/nofriendbg.png'


const _withScopeId = n => (_pushScopeId("data-v-0fcdefb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = {
  class: "topBox",
  style: {"height":"56px"}
}
const _hoisted_3 = { class: "navTitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_6 = {
  class: "iconBox",
  style: {"margin-top":"56px","padding-top":"10px"}
}
const _hoisted_7 = { class: "Box" }
const _hoisted_8 = { class: "titlebox" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_11 = {
  class: "Box",
  style: {"background":"linear-gradient(-30deg, rgba(137,247,254,0.76), rgba(102,166,255,0.76))"}
}
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_14 = {
  key: 0,
  style: {"margin-bottom":"100px","margin-top":"20px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "avatar" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "userInfo" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = {
  key: 0,
  class: "online"
}
const _hoisted_21 = {
  key: 1,
  class: "noline"
}
const _hoisted_22 = {
  key: 2,
  class: "noline"
}
const _hoisted_23 = {
  key: 1,
  class: "noFriendBox"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "tuijian" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "zbbox" }
const _hoisted_30 = { class: "userinfo" }
const _hoisted_31 = { class: "info" }
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_van_index_anchor = _resolveComponent("van-index-anchor")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_index_bar = _resolveComponent("van-index-bar")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('home.Friend')), 1 /* TEXT */),
        ($setup.isWebclip || $setup.th == 'th')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "searchBox1",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/imsearch')))
            }, [
              _hoisted_4,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('im.search')), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "searchBox",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/imsearch')))
            }, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('im.search')), 1 /* TEXT */)
            ])),
        ((!$setup.isWebclip && $setup.th != 'th'))
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              onClick: $setup.showDownApp,
              src: _imports_1,
              alt: ""
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "cloumBox",
            onClick: $setup.toNewFriend
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('im.newFriend')), 1 /* TEXT */),
              ($setup.badge > 0)
                ? (_openBlock(), _createBlock(_component_van_badge, {
                    key: 0,
                    content: $setup.badge,
                    max: "99",
                    class: "badge"
                  }, null, 8 /* PROPS */, ["content"]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" <van-badge :content=\"badge\" max=\"99\" class=\"badge\" /> ")
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('tips.gd')), 1 /* TEXT */)
          ]),
          _hoisted_10,
          _createCommentVNode(" <van-badge :content=\"badge\"  max=\"99\" class=\"badge\" /> ")
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "cloumBox",
            onClick: $setup.toGroup
          }, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('im.mygfoup')), 1 /* TEXT */),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('im.mygscj')), 1 /* TEXT */)
          ]),
          _hoisted_13
        ])
      ]),
      _createCommentVNode(" lastlogouttime "),
      ($setup.isfriendList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_van_index_bar, { "sticky-offset-top": 56 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.friendList, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createVNode(_component_van_index_anchor, {
                      index: item.sort,
                      style: {"color":"#919191"}
                    }, null, 8 /* PROPS */, ["index"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (item_data) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "userBox",
                        onClick: ($event: any) => ($setup.toChat(item_data))
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_van_image, {
                            round: "",
                            width: "40",
                            fit: "cover",
                            height: "40",
                            src: item_data.headurl
                          }, null, 8 /* PROPS */, ["src"]),
                          (item_data.type == 1)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: $setup.zbtype,
                                alt: ""
                              }, null, 8 /* PROPS */, _hoisted_17))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item_data.nickname), 1 /* TEXT */),
                          (item_data.lastlogouttime == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('im.nowonline')), 1 /* TEXT */))
                            : (item_data.lastlogouttime == -1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('im.latestonline')), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.IMformatDate(item_data.lastlogouttime)) + _toDisplayString(_ctx.$t('im.online')), 1 /* TEXT */))
                        ])
                      ], 8 /* PROPS */, _hoisted_15))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "defut",
              style: _normalizeStyle({ marginTop: $setup.isWebclip ? '90px' : 0 })
            }, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('noData.noNewfriend')), 1 /* TEXT */),
              (!$setup.is_lb)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('tips.addzb')), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 4 /* STYLE */),
            _withDirectives(_createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('im.wntuij')), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotzb, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_van_image, {
                      src: item.portrait,
                      width: "47",
                      height: "47",
                      round: "",
                      fit: "cover"
                    }, null, 8 /* PROPS */, ["src"]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", null, _toDisplayString(item.nickname), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: $setup.showDownApp
                  }, _toDisplayString(_ctx.$t('im.add')), 1 /* TEXT */)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vShow, !$setup.isWebclip]
            ])
          ]))
    ]),
    _createCommentVNode(" <van-overlay :show=\"downloadshow\" @click=\"downloadshow = false\" z-index=\"999\">\n    <div class=\"flexcenter\" style=\"min-height: 100vh\" @click.stop>\n      <div class=\"dolne\">\n        <div class=\"dolne-box\">\n          <img class=\"dolne-bg\" :src=\"showDialogBg\" alt=\"\" />\n          <img class=\"dolne-jiantou\" @click=\"open()\" :src=\"jiantou\" alt=\"\" />\n        </div>\n        <img class=\"dolne-on\" @click=\"downloadshow = false\" :src=\"ICON_CLOSE\" alt=\"\" />\n      </div>\n    </div>\n  </van-overlay> "),
    _createVNode(_component_van_overlay, {
      show: $setup.downloadshow,
      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.downloadshow = false)),
      "z-index": "99999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("img", {
            class: "bg",
            src: $setup.arterBg,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_32),
          _createElementVNode("img", {
            class: "btn",
            src: $setup.arterBtn,
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.open())),
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_33),
          _createElementVNode("img", {
            class: "offbtn",
            src: $setup.offArterBtn,
            alt: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.downloadshow = false))
          }, null, 8 /* PROPS */, _hoisted_34)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}